<template>
  <v-row>
    <v-col cols="12" class="pa-0">
      <v-card flat>
        <v-card-title primary-title>
          <h2>Számlák</h2>
        </v-card-title>
        <v-card-text>
          <v-row>
            <v-col cols="12" class="py-0">
              <v-row>
                <v-col cols="12" md="2" hidden-xs-only class="py-0">
                  <v-btn :block="true" color="primary" @click="$router.go(-1)">
                    Vissza
                  </v-btn>
                </v-col>
                <v-col cols="12" md="2" offset-md="3" class="py-0">
                  <v-btn
                    :block="true"
                    color="success"
                    :to="`/telefonok/${this.$route.params.id}`"
                  >
                    Telefon Adatlap
                  </v-btn>
                </v-col>
                <v-col cols="12" md="2" class="py-0">
                  <v-btn disabled :block="true" color="success" to="newSzamla">
                    Új számla
                  </v-btn>
                </v-col>
                <v-col cols="12" md="3" class="py-0">
                  <v-text-field
                    v-model="filter"
                    label="Keresés"
                    append-icon="search"
                  />
                </v-col>
              </v-row>
            </v-col>
            <v-col cols="12" class="py-0">
              <v-data-table
                :items="items"
                :headers="headers"
                :loading="isLoading"
                :search="filter"
                :footer-props="{ showFirstLastPage: true }"
              >
                <template v-slot:[`item.muveletek`]="{ item }">
                  <v-row>
                    <v-col cols="12" md="6" pr-1>
                      <v-btn
                        :block="true"
                        color="success"
                        :to="`szamlak/${item.id}`"
                      >
                        Adatlap
                      </v-btn>
                    </v-col>
                    <v-col cols="12" md="6">
                      <v-btn
                        :block="true"
                        color="error"
                        @click="deleteSzamla(item.id)"
                      >
                        Számla Törlése
                      </v-btn>
                    </v-col>
                  </v-row>
                </template>
              </v-data-table>
            </v-col>
          </v-row>
        </v-card-text>
      </v-card>
    </v-col>
    <v-col class="d-sm-none">
      <v-btn color="info" fab bottom left fixed @click="$router.go(-1)"
        ><v-icon>arrow_left</v-icon></v-btn
      >
    </v-col>
  </v-row>
</template>

<script>
export default {
  title: "Számlák",
  data() {
    return {
      isLoading: true,
      filter: "",
      items: [],
      headers: [
        { text: "Azonosító", value: "id" },
        { text: "Év - Hónap", value: "targyho" },
        { text: "Összeg", value: "osszeg" },
        { text: "Parkolás", value: "parkolas" },
        { text: "Műveletek", value: "muveletek" }
      ],
      igennem: [{ value: 0, text: "Nem" }, { value: 1, text: "Igen" }],
      deleted: 0
    };
  },
  watch: {
    deleted: function() {
      this.getData();
    }
  },
  beforeMount() {
    this.getData();
  },
  methods: {
    deleteSzamla(id) {
      this.$axios.post("telefonok/deleteSzamla", { id: id }).then(() => {
        this.getData();
      });
    },
    getData() {
      this.items = [];
      this.isLoading = true;
      this.$axios
        .get(`telefonok/szamlak/${this.$route.params.id}`)
        .then(response => {
          this.items = response.data;
          this.isLoading = false;
        });
    }
  }
};
</script>

<style lang="stylus"></style>
